/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {AbstractContactVO} from "@well/domain";

export class BpSelectableContact {

  contact!: AbstractContactVO;
  selected = false;

  disabled = false;

  constructor(contact: AbstractContactVO, selected: boolean, disabled = false) {
    this.contact = contact;
    this.selected = selected;
    this.disabled = disabled;
  }

}
